import React, { useState, useEffect, useMemo } from 'react';
import html2pdf from 'html2pdf.js';
import { useNavigate } from 'react-router-dom';
import {
  Calculator,
  FileText,
  Download,
  Users,
  DollarSign,
  Calendar,
  Building,
  CheckCircle,
  AlertCircle,
  TrendingUp,
} from 'lucide-react';
import {
 
  Button,
 
} from '@mui/material';
import config from '../config/config';
import axios from 'axios';

const KenyanPayroll = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('payroll');
  const [showProcessModal, setShowProcessModal] = useState(false);
  const [showReportsModal, setShowReportsModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
  const [nssfTier, setNssfTier] = useState('both');
  const [employees, setEmployees] = useState([]);
  const [payrollData, setPayrollData] = useState([]);
  const [benefitsDeductions, setBenefitsDeductions] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
  const [inputValue, setInputValue] = useState(""); 
const handleSearch = () => {
   fetchWithCache('payrollData', `${config.API_URL}/api/pull_payrolls/`+inputValue, setPayrollData, token);
  };

  // Fetch employees
  const fetchEmployees = async (companyId = 1) => {
    try {
      const response = await axios.get(`${config.API_URL}/api/pullemployees`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      //////console.log('Employees API response:', response.data);
      setEmployees(response.data.data || []);
     
      //console.log('Employees API response:', data);
    
          } catch (err) {
      setError('Failed to fetch employees');
      //console.error('Fetch employees error:', err);
    }
  };

  const checkTab = async (tab) => {
      if(tab==='employees' || tab==="salaries"){
        navigate('/salaries');
      }
  }


  // Fetch benefits/deductions
  const fetchBenefitsDeductions = async (companyId = 1) => {
    try {
      const response = await fetch(`${config.API_URL}/api/benefits-deductions/${companyId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
      const data = await response.json();
      //console.log('Benefits/Deductions API response:', data);
      setBenefitsDeductions(data.data || []);
    } catch (err) {
      setError('Failed to fetch benefits/deductions');
      //console.error('Fetch benefits/deductions error:', err);
    }
  };

  // Process payroll
  const processPayroll = async () => {
    setProcessing(true);
    setError(null);
    const [year, month] = selectedMonth.split('-');
    const companyId = 1;

    try {
      const response = await fetch(
        `${config.API_URL}/api/payroll/process/${companyId}/${year}/${month}?nssfTier=${nssfTier}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        }
      );
      const result = await response.json();
      //console.log('Process payroll API response:', result);
      if (result.status === 'success') {
        const payrollResponse = await fetch(`${config.API_URL}/api/payroll/${companyId}/${year}/${month}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        });
        const payrollResult = await payrollResponse.json();
        ////console.log('Payroll data API response:', payrollResult);
        setPayrollData(payrollResult.data || []);
        setShowProcessModal(false);
      } else {
        setError(result.message || 'Failed to process payroll');
      }
    } catch (err) {
      setError('Failed to process payroll');
      //console.error('Process payroll error:', err);
    } finally {
      setProcessing(false);
    }
  };

  const TTL = 1000 * 0 * 60; // 10 minutes

  const getCachedData = (key) => {
    const cached = localStorage.getItem(key);
    if (!cached) return null;
    try {
      const { data, timestamp } = JSON.parse(cached);
      if (Date.now() - timestamp > TTL) {
        localStorage.removeItem(key);
        setLoading(false);
        return null;
      }
      setLoading(false);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      setLoading(false);
      //console.error('Cache parse error:', e);
      return null;
    }
  };

  const setCachedData = (key, data) => {
    const payload = { data, timestamp: Date.now() };
    setLoading(false);
    localStorage.setItem(key, JSON.stringify(payload));
  };

  const fetchWithCache = async (key, url, setter, token, useParams = false, params = {}) => {
    const cached = getCachedData(key);
    if (cached) {
      setter(cached);
      //console.log(`Using cached data for ${key}:`, cached);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
        ...(useParams ? { params } : {}),
      });
      const result = response.data.data || response.data || [];
      setSelectedMonth(response.data.payrollMonth);

      //console.log(`API response for ${key}:`, result);
      setter(Array.isArray(result) ? result : []);
      setCachedData(key, result);
    } catch (error) {
      setLoading(false);
      //console.error(`Error fetching ${key}:`, error);
      setter([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      setError('No token found. Please log in.');
      return;
    }
    //console.log('Fetching initial data with token:', token);
    fetchWithCache('payrollData', `${config.API_URL}/api/pull_payrolls`, setPayrollData, token);
    fetchEmployees();
    fetchBenefitsDeductions();
  }, [token]);

  // Generate reports
  const generateReport = async (type) => {

    setGenerating(true);
    setError(null);
    const [year, month] = selectedMonth.split('-');
    const companyId = 1;
    let endpoint = config.API_URL;
    let filename = `${type}_report_${year}_${month}`;

    switch (type) {
      case 'nssf':
        endpoint += `/api/payroll/nssf/${companyId}/${year}/${month}`;
        break;
         case 'nita':
        endpoint += `/api/payroll/nssf/${companyId}/${year}/${month}`;
        break;
      case 'shif':
        endpoint += `/api/payroll/shif/${companyId}/${year}/${month}`;
        break;
      case 'housing':
        endpoint += `/api/payroll/housing/${companyId}/${year}/${month}`;
        break;
      case 'p9':
        endpoint += `/api/payroll/p9/${companyId}/${year}`;
        filename = `${type}_report_${year}`;
        break;
      case 'payslips':
        endpoint += `/api/payroll/payslips/${companyId}/${year}/${month}`;
        break;
      case 'paye':
        endpoint += `/api/payroll/payslips/${companyId}/${year}/${month}`;
        break;
      case 'summary':
        endpoint += `/api/payroll/summary/${companyId}/${year}/${month}`;
       
        break;
      default:
        setError(`Invalid report type: ${type}`);
        setGenerating(false);
        return;
    }

    try {
      //console.log(`Fetching report data from: ${endpoint}`);
      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      //console.log('Report API response headers:', response.headers.get('content-type'));
      if (!response.ok) {
        //console.error(`API error for ${type}: ${response.status} ${response.statusText}`);
        throw new Error(`API error: ${response.status} ${response.statusText}`);
      }

      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        //console.error(`Invalid content type for ${type}: ${contentType}`);
        throw new Error(`Expected JSON response, got: ${contentType}`);
      }

      const data = await response.json();
      //console.log(`Raw report data for ${type}:`, data);

      if (data.status !== 'success' || !Array.isArray(data.data)) {
        //console.warn(`Invalid response for ${type}:`, data);
        if (payrollData.length > 0) {
          //console.log(`Falling back to payrollData for ${type}`);
        } else {
          throw new Error(data.message || `No data available for ${type} report`);
        }
      }

      // Transform data with fallback calculations
      const reportData = (data.status === 'success' && Array.isArray(data.data) && data.data.length > 0)
        ? data.data.map(item => ({
            user_id: item.user_id || '',
            name: item.name || 'N/A',
            kra_pin: item.kra_pin || 'N/A',
            nssf_number: item.nssf_number || 'N/A',
            sha_number: item.sha_number || 'N/A',
            employee_id: item.employee_id || item.user_id || 'N/A',
            department: item.department || 'N/A',
            gross_salary: Number(item.gross_salary || 0),
            paye: Number(item.paye || 0),
            shif: Number(item.shif || Math.max((item.gross_salary || 0) * 0.0275, 300)),
            nssf: Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)),
            housing_levy: Number(item.housing_levy || (item.gross_salary || 0) * 0.015),
            net_pay: Number(item.net_pay || 0),
            created_at: item.created_at || new Date().toISOString(),
            ...item,
          }))
        : payrollData.map(item => ({
            user_id: item.user_id || '',
            name: item.name || 'N/A',
            kra_pin: item.kra_pin || 'N/A',
            nssf_number: item.nssf_number || 'N/A',
            sha_number: item.sha_number || 'N/A',
            employee_id: item.employee_id || item.user_id || 'N/A',
            department: item.department || 'N/A',
            gross_salary: Number(item.gross_salary || 0),
            paye: Number(item.paye || 0),
            shif: Number(item.shif || Math.max((item.gross_salary || 0) * 0.0275, 300)),
            nssf: Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)),
            housing_levy: Number(item.housing_levy || (item.gross_salary || 0) * 0.015),
            net_pay: Number(item.net_pay || 0),
            created_at: item.created_at || new Date().toISOString(),
            ...item,
          }));

      if (reportData.length === 0) {
        throw new Error(`No valid data for ${type} report after fallback`);
      }

      //console.log(`Transformed report data for ${type}:`, reportData);

      const element = document.createElement('div');
      element.innerHTML = generateReportContent(type, reportData, year, month);
      if(type=="summary"){
         window.open(config.API_URL+'/payroll_reports/'+year+'-'+month+'/'+token);
      }else if(type=="paye"){
         window.open(config.API_URL+'/paye/'+year+'-'+month+'/'+token);
      }
      else if(type=="shif"){
         window.open(config.API_URL+'/shif/'+year+'-'+month+'/'+token);
      }
      else if(type=="nssf"){
         window.open(config.API_URL+'/nssf/'+year+'-'+month+'/'+token);
      }
      else if(type=="nita"){
         window.open(config.API_URL+'/nita/'+year+'-'+month+'/'+token);
      }else if(type=="housing"){
         window.open(config.API_URL+'/housing_levy/'+year+'-'+month+'/'+token);
      }
      
        setGenerating(false);
      const opt = {
        margin: type === 'payslips' && reportData.length === 1 ? [0.5, 2, 0.5, 2] : 0.2,
        filename: `${filename}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: 'in',
          format: 'letter',
          orientation: type === 'payslips' && reportData.length === 1 ? 'portrait' : 'landscape',
        },
      };
      //console.log(`Generating PDF for ${type} with options:`, opt);
     // await html2pdf().set(opt).from(element).save();
    } catch (err) {
      //console.error(`Failed to generate ${type} PDF report:`, err);
      setError(`Failed to generate ${type} PDF report: ${err.message}`);
    } finally {
      setGenerating(false);
      setShowReportsModal(false);
    }
  };

  // Download individual payslip
  const downloadPayslip = async (employee) => {
    setGenerating(true);
    setError(null);
    //console.log('Attempting to download payslip for employee:', employee);

    const [year, month] = selectedMonth.split('-');
    const companyId = 1;
    const filename = `payslip_${(employee.name || 'employee').replace(/\s+/g, '_')}_${year}_${month}.pdf`;

    try {
       window.open(config.API_URL+'/payslip/'+year+'-'+month+'/'+employee.user_id+'/'+token);
      {/*let employeePayslip = payrollData.find((item) => item.user_id === employee.user_id) || employee;
      //console.log('Employee payslip from payrollData:', employeePayslip);

      if (!employeePayslip || !employeePayslip.gross_salary) {
        //console.log('No valid payslip data in payrollData, fetching from API');
        const endpoint = `${config.API_URL}/api/payroll/payslips/${companyId}/${year}/${month}`;
        //console.log(`Fetching payslip from: ${endpoint}`);
        const response = await fetch(endpoint, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        });

        //console.log('Payslip API response headers:', response.headers.get('content-type'));
        if (!response.ok) {
          throw new Error(`API error: ${response.status} ${response.statusText}`);
        }

        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          throw new Error(`Expected JSON response, got: ${contentType}`);
        }

        const data = await response.json();
        //console.log(`Payslip API response for ${employee.name}:`, data);

        if (data.status !== 'success' || !Array.isArray(data.data)) {
          throw new Error(data.message || 'Invalid response for payslip');
        }

        employeePayslip = data.data.find((item) => item.user_id === employee.user_id) || employee;
        //console.log('Employee payslip from API:', employeePayslip);
      }

      if (!employeePayslip || !employeePayslip.name) {
        throw new Error(`No payslip data found for ${employee.name || 'employee'}`);
      }

      // Transform payslip data
      employeePayslip = {
        ...employeePayslip,
        kra_pin: employeePayslip.kra_pin || 'N/A',
        nssf_number: employeePayslip.nssf_number || 'N/A',
        sha_number: employeePayslip.sha_number || 'N/A',
        employee_id: employeePayslip.employee_id || employeePayslip.user_id || 'N/A',
        department: employeePayslip.department || 'N/A',
        gross_salary: Number(employeePayslip.gross_salary || 0),
        paye: Number(employeePayslip.paye || 0),
        shif: Number(employeePayslip.shif || Math.max((employeePayslip.gross_salary || 0) * 0.0275, 300)),
        nssf: Number(employeePayslip.nssf || Math.min((employeePayslip.gross_salary || 0) * 0.06, 8000)),
        housing_levy: Number(employeePayslip.housing_levy || (employeePayslip.gross_salary || 0) * 0.015),
        net_pay: Number(employeePayslip.net_pay || 0),
      };

      const element = document.createElement('div');
      element.innerHTML = generateReportContent('payslips', [employeePayslip], year, month);
      const opt = {
        margin: [0.5, 2, 0.5, 2],
        filename,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      };
      //console.log(`Generating payslip PDF with options:`, opt);
      await html2pdf().set(opt).from(element).save();*/}
    } catch (err) {
      //console.error(`Failed to generate payslip for ${employee.name || 'employee'}:`, err);
      setError(`Failed to generate payslip for ${employee.name || 'employee'}: ${err.message}`);
    } finally {
      setGenerating(false);
    }
  };

  // Generate HTML content for PDF
  const generateReportContent = (type, data, year, month) => {
    const safeData = Array.isArray(data) ? data : [];
    //console.log(`Generating report content for ${type} with data:`, safeData);
    const monthName = new Date(`${year}-${month}-01`).toLocaleString('default', { month: 'long' });
    const date = new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

    // Company branding
    const companyHeader = `
      <div style="text-align: center; margin-bottom: 0.5in;">
        <img src="https://via.placeholder.com/100x50?text=Logo" alt="Company Logo" style="width: 1in; height: auto;" />
        <div style="font-size: 16px; font-weight: 500;">Your Company Name</div>
        <div style="font-size: 12px;">P.O. Box 12345, Nairobi, Kenya</div>
      </div>
    `;

    // Payslip: Zoho-style receipt
    if (type === 'payslips' && safeData.length === 1) {
      const employee = safeData[0];
      const benefits = benefitsDeductions
        .filter(bd => bd.type === 'benefit')
        .map(bd => ({
          name: bd.name,
          amount: Number(employee[bd.name] || employee.details?.[bd.name] || 0),
        }))
        .filter(b => b.amount > 0);
      const deductions = [
        { name: 'PAYE', amount: Number(employee.paye || 0) },
        { name: 'SHIF', amount: Number(employee.shif || Math.max((employee.gross_salary || 0) * 0.0275, 300)) },
        { name: 'NSSF', amount: Number(employee.nssf || Math.min((employee.gross_salary || 0) * 0.06, 8000)) },
        { name: 'Housing Levy', amount: Number(employee.housing_levy || (employee.gross_salary || 0) * 0.015) },
        ...benefitsDeductions
          .filter(bd => bd.type === 'deduction')
          .map(bd => ({
            name: bd.name,
            amount: Number(employee[bd.name] || employee.details?.[bd.name] || 0),
          })),
      ].filter(d => d.amount > 0);
      const totalDeductions = deductions.reduce((sum, d) => sum + d.amount, 0);
      const totalEarnings = Number(employee.gross_salary || 0) + benefits.reduce((sum, b) => sum + b.amount, 0);
      const personalRelief = 2400;

      return `
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
          body { font-family: 'Roboto', sans-serif; }
          .receipt { width: 4in; margin: 0 auto; background: #fff; padding: 0.5in; font-size: 12px; color: #333; line-height: 1.5; }
          .divider { border-top: 1px dashed #ccc; margin: 0.3in 0; }
          .section-title { font-size: 13px; font-weight: 500; margin: 0.2in 0 0.1in; color: #222; }
          .item { display: flex; justify-content: space-between; margin-bottom: 0.1in; }
          .item-label { font-weight: 400; color: #555; }
          .item-value { font-weight: 400; }
          .total { display: flex; justify-content: space-between; font-weight: 500; font-size: 14px; margin-top: 0.2in; }
          .footer { text-align: center; margin-top: 0.5in; font-size: 10px; color: #777; }
        </style>
        <div class="receipt">
          ${companyHeader}
          <div style="text-align: center; font-size: 14px;">Payslip for ${monthName} ${year}</div>
          <div style="text-align: center; font-size: 12px;">Issued on ${date}</div>
          <div class="divider"></div>
          <div>
            <div class="item"><span class="item-label">Employee</span><span class="item-value">${employee.name || 'N/A'}</span></div>
            <div class="item"><span class="item-label">Employee ID</span><span class="item-value">${employee.employee_id || 'N/A'}</span></div>
            <div class="item"><span class="item-label">KRA PIN</span><span class="item-value">${employee.kra_pin || 'N/A'}</span></div>
            <div class="item"><span class="item-label">NSSF No.</span><span class="item-value">${employee.nssf_number || 'N/A'}</span></div>
            <div class="item"><span class="item-label">SHA No.</span><span class="item-value">${employee.sha_number || 'N/A'}</span></div>
            <div class="item"><span class="item-label">Department</span><span class="item-value">${employee.department || 'N/A'}</span></div>
          </div>
          <div class="divider"></div>
          <div class="section-title">Earnings</div>
          <div class="item"><span class="item-label">Basic Salary</span><span class="item-value">KES ${Number(employee.gross_salary || 0).toLocaleString()}</span></div>
          ${benefits.map(b => `
            <div class="item"><span class="item-label">${b.name}</span><span class="item-value">KES ${b.amount.toLocaleString()}</span></div>
          `).join('')}
          <div class="total"><span>Total Earnings</span><span>KES ${totalEarnings.toLocaleString()}</span></div>
          <div class="divider"></div>
          <div class="section-title">Deductions</div>
          ${deductions.map(d => `
            <div class="item"><span class="item-label">${d.name}</span><span class="item-value">KES ${d.amount.toLocaleString()}</span></div>
          `).join('')}
          <div class="item"><span class="item-label">Personal Relief</span><span class="item-value">KES ${personalRelief.toLocaleString()}</span></div>
          <div class="total"><span>Total Deductions</span><span>KES ${(totalDeductions - personalRelief).toLocaleString()}</span></div>
          <div class="divider"></div>
          <div class="total" style="font-size: 16px; color: #000;">
            <span>Net Pay</span><span>KES ${Number(employee.net_pay || totalEarnings - totalDeductions + personalRelief).toLocaleString()}</span>
          </div>
          <div class="footer">
            <div>Contact: payroll@yourcompany.com | +254 700 123 456</div>
            <div>Generated by Your Company Name</div>
          </div>
        </div>
      `;
    }

    // P9 Form: KRA-compliant
    if (type === 'p9') {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `
        <style>
          body { font-family: Arial, sans-serif; font-size: 10px; }
          table { width: 100%; border-collapse: collapse; margin-top: 0.2in; }
          th, td { border: 1px solid #ddd; padding: 6px; text-align: right; }
          th { background: #f4f4f4; font-weight: bold; }
          .left { text-align: left; }
          .total { font-weight: bold; background: #f9f9f9; }
        </style>
        ${companyHeader}
        <h2 style="text-align: center; font-size: 14px;">P9 Form - Tax Deduction Card ${year}</h2>
        ${safeData.map(employee => {
          const monthlyData = Array(12).fill().map((_, i) => ({
            basic_salary: Number(employee[`basic_salary_${i + 1}`] || employee.gross_salary || 0),
            benefits: benefitsDeductions
              .filter(bd => bd.type === 'benefit')
              .reduce((sum, bd) => sum + Number(employee[`${bd.name}_${i + 1}`] || employee[bd.name] || 0), 0),
            paye: Number(employee[`paye_${i + 1}`] || employee.paye || 0),
            personal_relief: 2400,
          }));
          const totalBasic = monthlyData.reduce((sum, m) => sum + m.basic_salary, 0);
          const totalBenefits = monthlyData.reduce((sum, m) => sum + m.benefits, 0);
          const totalPaye = monthlyData.reduce((sum, m) => sum + m.paye, 0);
          const totalRelief = monthlyData.reduce((sum, m) => sum + m.personal_relief, 0);
          return `
            <div style="margin-bottom: 0.5in;">
              <div style="font-size: 12px; margin-bottom: 0.2in;">
                <span>Employee: ${employee.name || 'N/A'}</span><br/>
                <span>KRA PIN: ${employee.kra_pin || 'N/A'}</span>
              </div>
              <table>
                <thead>
                  <tr>
                    <th class="left">Month</th>
                    <th>Basic Salary</th>
                    <th>Benefits</th>
                    <th>Gross Pay</th>
                    <th>PAYE</th>
                    <th>Personal Relief</th>
                    <th>Net Tax</th>
                  </tr>
                </thead>
                <tbody>
                  ${monthlyData.map((m, i) => `
                    <tr>
                      <td class="left">${months[i]}</td>
                      <td>KES ${m.basic_salary.toLocaleString()}</td>
                      <td>KES ${m.benefits.toLocaleString()}</td>
                      <td>KES ${(m.basic_salary + m.benefits).toLocaleString()}</td>
                      <td>KES ${m.paye.toLocaleString()}</td>
                      <td>KES ${m.personal_relief.toLocaleString()}</td>
                      <td>KES ${(m.paye - m.personal_relief < 0 ? 0 : m.paye - m.personal_relief).toLocaleString()}</td>
                    </tr>
                  `).join('')}
                  <tr class="total">
                    <td class="left">Total</td>
                    <td>KES ${totalBasic.toLocaleString()}</td>
                    <td>KES ${totalBenefits.toLocaleString()}</td>
                    <td>KES ${(totalBasic + totalBenefits).toLocaleString()}</td>
                    <td>KES ${totalPaye.toLocaleString()}</td>
                    <td>KES ${totalRelief.toLocaleString()}</td>
                    <td>KES ${(totalPaye - totalRelief < 0 ? 0 : totalPaye - totalRelief).toLocaleString()}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          `;
        }).join('')}
        <div style="text-align: center; font-size: 10px; margin-top: 0.2in;">
          Generated for KRA iTax Submission | Contact: payroll@yourcompany.com
        </div>
      `;
    }

    // SHIF, NSSF, Housing Levy, PAYE, Summary Reports
    const reportConfigs = {
      shif: {
        title: `SHIF Contributions Report - ${monthName} ${year}`,
        headers: ['Employee', 'KRA PIN', 'SHA No.', 'Gross Salary', 'SHIF Contribution'],
        rowMapper: item => [
          item.name || 'N/A',
          item.kra_pin || 'N/A',
          item.sha_number || 'N/A',
          `KES ${Number(item.gross_salary || 0).toLocaleString()}`,
          `KES ${Number(item.shif || Math.max((item.gross_salary || 0) * 0.0275, 300)).toLocaleString()}`,
        ],
        totals: [
          'Total', '', '',
          `KES ${safeData.reduce((sum, item) => sum + Number(item.gross_salary || 0), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.shif || Math.max((item.gross_salary || 0) * 0.0275, 300)), 0).toLocaleString()}`,
        ],
      },
      nssf: {
        title: `NSSF Contributions Report - ${monthName} ${year}`,
        headers: ['Employee', 'KRA PIN', 'NSSF No.', 'Gross Salary', 'Employee Contribution', 'Employer Contribution'],
        rowMapper: item => [
          item.name || 'N/A',
          item.kra_pin || 'N/A',
          item.nssf_number || 'N/A',
          `KES ${Number(item.gross_salary || 0).toLocaleString()}`,
          `KES ${Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)).toLocaleString()}`,
          `KES ${Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)).toLocaleString()}`,
        ],
        totals: [
          'Total', '', '',
          `KES ${safeData.reduce((sum, item) => sum + Number(item.gross_salary || 0), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)), 0).toLocaleString()}`,
        ],
      },
      housing: {
        title: `Housing Levy Report - ${monthName} ${year}`,
        headers: ['Employee', 'KRA PIN', 'Gross Salary', 'Employee Levy', 'Employer Levy'],
        rowMapper: item => [
          item.name || 'N/A',
          item.kra_pin || 'N/A',
          `KES ${Number(item.gross_salary || 0).toLocaleString()}`,
          `KES ${Number(item.housing_levy || (item.gross_salary || 0) * 0.015).toLocaleString()}`,
          `KES ${Number(item.housing_levy || (item.gross_salary || 0) * 0.015).toLocaleString()}`,
        ],
        totals: [
          'Total', '',
          `KES ${safeData.reduce((sum, item) => sum + Number(item.gross_salary || 0), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.housing_levy || (item.gross_salary || 0) * 0.015), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.housing_levy || (item.gross_salary || 0) * 0.015), 0).toLocaleString()}`,
        ],
      },
      paye: {
        title: `PAYE Schedule - ${monthName} ${year}`,
        headers: ['Employee', 'KRA PIN', 'Gross Salary', 'PAYE', 'Personal Relief'],
        rowMapper: item => [
          item.name || 'N/A',
          item.kra_pin || 'N/A',
          `KES ${Number(item.gross_salary || 0).toLocaleString()}`,
          `KES ${Number(item.paye || 0).toLocaleString()}`,
          `KES 2400`,
        ],
        totals: [
          'Total', '',
          `KES ${safeData.reduce((sum, item) => sum + Number(item.gross_salary || 0), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.paye || 0), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + 2400, 0).toLocaleString()}`,
        ],
      },
      summary: {
        title: `Payroll Summary - ${monthName} ${year}`,
        headers: ['Employee', 'Gross Salary', 'PAYE', 'SHIF', 'NSSF', 'Housing Levy', 'Net Pay'],
        rowMapper: item => [
          item.name || 'N/A',
          `KES ${Number(item.gross_salary || 0).toLocaleString()}`,
          `KES ${Number(item.paye || 0).toLocaleString()}`,
          `KES ${Number(item.shif || Math.max((item.gross_salary || 0) * 0.0275, 300)).toLocaleString()}`,
          `KES ${Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)).toLocaleString()}`,
          `KES ${Number(item.housing_levy || (item.gross_salary || 0) * 0.015).toLocaleString()}`,
          `KES ${Number(item.net_pay || 0).toLocaleString()}`,
        ],
        totals: [
          'Total',
          `KES ${safeData.reduce((sum, item) => sum + Number(item.gross_salary || 0), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.paye || 0), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.shif || Math.max((item.gross_salary || 0) * 0.0275, 300)), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.housing_levy || (item.gross_salary || 0) * 0.015), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.net_pay || 0), 0).toLocaleString()}`,
        ],
      },
      payslips: {
        title: `Employee Payslips - ${monthName} ${year}`,
        headers: ['Employee', 'Gross Salary', 'PAYE', 'SHIF', 'NSSF', 'Housing Levy', 'Net Pay'],
        rowMapper: item => [
          item.name || 'N/A',
          `KES ${Number(item.gross_salary || 0).toLocaleString()}`,
          `KES ${Number(item.paye || 0).toLocaleString()}`,
          `KES ${Number(item.shif || Math.max((item.gross_salary || 0) * 0.0275, 300)).toLocaleString()}`,
          `KES ${Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)).toLocaleString()}`,
          `KES ${Number(item.housing_levy || (item.gross_salary || 0) * 0.015).toLocaleString()}`,
          `KES ${Number(item.net_pay || 0).toLocaleString()}`,
        ],
        totals: [
          'Total',
          `KES ${safeData.reduce((sum, item) => sum + Number(item.gross_salary || 0), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.paye || 0), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.shif || Math.max((item.gross_salary || 0) * 0.0275, 300)), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.housing_levy || (item.gross_salary || 0) * 0.015), 0).toLocaleString()}`,
          `KES ${safeData.reduce((sum, item) => sum + Number(item.net_pay || 0), 0).toLocaleString()}`,
        ],
      },
    };

    const config = reportConfigs[type] || reportConfigs.summary;
    const htmlContent = `
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; }
        table { width: 100%; border-collapse: collapse; margin-top: 0.2in; }
        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
        th { background: #f4f4f4; font-weight: bold; }
        .total { font-weight: bold; background: #f9f9f9; }
      </style>
      ${companyHeader}
      <h2 style="text-align: center; margin-bottom: 0.2in;">${config.title}</h2>
      <table>
        <thead>
          <tr>${config.headers.map(header => `<th>${header}</th>`).join('')}</tr>
        </thead>
        <tbody>
          ${safeData.map(item => `
            <tr>${config.rowMapper(item).map(cell => `<td>${cell}</td>`).join('')}</tr>
          `).join('')}
        </tbody>
        <tfoot>
          <tr class="total">${config.totals.map(cell => `<td>${cell}</td>`).join('')}</tr>
        </tfoot>
      </table>
      <div style="text-align: center; font-size: 10px; margin-top: 0.2in;">
        Generated on ${date} | Contact: payroll@yourcompany.com
      </div>
    `;
    //console.log(`Generated HTML content for ${type}:`, htmlContent);
    return htmlContent;
  };

  const {
    totalEmployees,
    totalGross,
    totalNet,
    totalDeductions,
    totalPaye,
    totalShif,
    totalCharge,
    totalNssf,
    totalHousing,
    benefitTotals,
    deductionTotals,
  } = useMemo(() => {
    const safePayroll = Array.isArray(payrollData) ? payrollData : [];
    //console.log('Computing totals with payrollData:', safePayroll);

    const totalEmployees = Array.isArray(employees) ? employees.length : 0;
    const totalGross = safePayroll.reduce((sum, emp) => sum + Number(emp.gross_salary || 0), 0);
    const totalNet = safePayroll.reduce((sum, emp) => sum + Number(emp.net_pay || 0), 0);
    const totalPaye = safePayroll.reduce((sum, emp) => sum + Number(emp.paye || 0), 0);
    const totalCharge = safePayroll.reduce((sum, emp) => sum + Number(emp.bank_transfer_charges || 0), 0);
    const totalShif = safePayroll.reduce((sum, emp) => sum + Number(emp.shif || Math.max((emp.gross_salary || 0) * 0.0275, 300)), 0);
    const totalNssf = safePayroll.reduce((sum, emp) => sum + Number(emp.nssf || Math.min((emp.gross_salary || 0) * 0.06, 8000)), 0);
    const totalHousing = safePayroll.reduce((sum, emp) => sum + Number(emp.housing_levy || (emp.gross_salary || 0) * 0.015), 0);

    const totalDeductions = totalPaye + totalShif + totalNssf + totalHousing+totalCharge;

    const benefitTotals = benefitsDeductions
      .filter(bd => bd.type === 'benefit')
      .map(bd => ({
        name: bd.name,
        total: safePayroll.reduce((sum, emp) => sum + Number(emp[bd.name] || emp.details?.[bd.name] || 0), 0),
      }));

    const deductionTotals = benefitsDeductions
      .filter(bd => bd.type === 'deduction')
      .map(bd => ({
        name: bd.name,
        total: safePayroll.reduce((sum, emp) => sum + Number(emp[bd.name] || emp.details?.[bd.name] || 0), 0),
      }));

    return {
      totalEmployees,
      totalGross,
      totalNet,
      totalPaye,
      totalShif,
      totalNssf,
      totalCharge,
      totalHousing,
      totalDeductions,
      benefitTotals,
      deductionTotals,
    };
  }, [payrollData, employees, benefitsDeductions]);

  const downloadPDF = async () => {
    setGenerating(true);
    setError(null);
    try {
      const element = document.getElementById('payroll-table');
      if (!element) {
        throw new Error('Payroll table element not found');
      }
      //console.log('Generating payroll table PDF');
      const opt = {
        margin: 0.2,
        filename: `payroll-summary-${new Date().toISOString().slice(0, 10)}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
      };
      await html2pdf().set(opt).from(element).save();
    } catch (err) {
      //console.error('Failed to generate payroll PDF:', err);
      setError(`Failed to generate payroll PDF: ${err.message}`);
    } finally {
      setGenerating(false);
    }
  };

  const StatCard = ({ title, value, icon: Icon, color, subtitle }) => (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className={`text-2xl font-bold ${color}`}>{value}</p>
          {subtitle && <p className="text-xs text-slate-500 mt-1">{subtitle}</p>}
        </div>
        <div className={`p-3 rounded-full ${color.replace('text', 'bg').replace('-600', '-100')}`}>
          <Icon className={`h-6 w-6 ${color}`} />
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <Building className="h-8 w-8 text-blue-600 mr-3" />
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Payroll Management</h1>
              </div>
            </div>
            <div className="flex space-x-4">
              <button
                onClick={() => setShowProcessModal(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center space-x-2 transition-colors"
              >
                <Calculator className="h-4 w-4" />
                <span>Process Payroll</span>
              </button>
              <button
                onClick={() => setShowReportsModal(true)}
                className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center space-x-2 transition-colors"
              >
                <FileText className="h-4 w-4" />
                <span>Reports</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
        <div className="flex space-x-8 border-b border-gray-200">
          {['payroll','employees',  'compliance'].map(tab => (
            <button
              key={tab}
              onClick={() => {setActiveTab(tab); checkTab(tab);}}
              className={`py-2 px-1 border-b-2 font-medium text-sm capitalize transition-colors ${
                activeTab === tab
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-slate-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">{error}</div>
        )}

        {activeTab === 'overview' && (
          <div className="space-y-6">
           

            <div className="bg-white rounded-xl shadow-sm border border-gray-100">
              <div className="px-6 py-4 border-b border-gray-100">
                <h3 className="text-lg font-semibold text-gray-900">Recent Payroll Activity</h3>
              </div>
              <div className="p-6">
                {payrollData.length > 0 ? (
                  <div className="space-y-4">
                    {payrollData.slice(0, 5).map(item => (
                      <div
                        key={item.user_id}
                        className="flex items-center justify-between p-4 bg-gray-50 rounded-lg"
                      >
                        <div className="flex items-center space-x-3">
                          <CheckCircle className="h-5 w-5 text-green-500" />
                          <div>
                            <p className="font-medium text-gray-900">{item.name || 'N/A'}</p>
                            <p className="text-sm text-gray-600">
                              Net: KES {Number(item.net_pay || 0).toLocaleString()}
                            </p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="text-sm text-gray-600">
                            {new Date(item.created_at || new Date()).toLocaleDateString()}
                          </p>
                          <p className="text-xs text-green-600">Processed</p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <Calculator className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-600">No payroll processed yet</p>
                    <p className="text-sm text-slate-500">Click "Process Payroll" to get started</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'employees' && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center">
              <h3 className="text-lg font-semibold text-gray-900">Employee Management</h3>
            </div>
            <div className="p-6">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                        Employee
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                        Department
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                        Basic Salary
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                        Bank
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {employees.map(employee => (
                      <tr key={employee.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div>
                            <div className="text-sm font-medium text-gray-900">{employee.name || 'N/A'}</div>
                            <div className="text-sm text-slate-500">{employee.employee_id || 'N/A'}</div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {employee.department || 'N/A'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          KES {Number(employee.basic_salary || 0).toLocaleString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {employee.bank || 'N/A'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'payroll' && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100">
           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <StatCard
                title="Total Employees"
                value={totalEmployees}
                icon={Users}
                color="text-blue-600"
                subtitle="Active employees"
              />
              <StatCard
                title="Gross Payroll"
                value={`KES ${totalGross.toLocaleString()}`}
                icon={TrendingUp}
                color="text-green-600"
                subtitle="Most recent payroll"
              />
              <StatCard
                title="Total Deductions"
                value={`KES ${totalDeductions.toLocaleString()}`}
                icon={AlertCircle}
                color="text-red-600"
                subtitle="PAYE, SHIF, NSSF, etc"
              />
              <StatCard
                title="Net Payroll"
                value={`KES ${totalNet.toLocaleString()}`}
                icon={DollarSign}
                color="text-purple-600"
                subtitle="Take home pay"
              />
            </div>
            <div className="flex justify-end mb-4 space-x-2 py-2 px-3">
              <button
                onClick={downloadPDF}
                disabled={generating}
                className="px-3 py-2 text-xs bg-info-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
              >
                {generating ? 'Generating...' : 'Export PDF'}
              </button>
            </div>
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900">Current Processed Payroll</h3>
              <div style={{ display: "flex", gap: "8px" }}>
      <input
        type="month"
        placeholder="Select month..."
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        style={{ padding: "8px", width: "300px" }}
      />
      <Button  sx={{
              backgroundColor: '#1976d2',
              '&:hover': { backgroundColor: '#1565c0' },
            }} onClick={handleSearch} style={{ padding: "8px 16px", color:"#fff" }}>
        Filter
      </Button>
    </div>
            </div>
            <div className="p-6" id="payroll-table">
              {payrollData.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                          Employee
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                          Gross
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                          PAYE
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                          SHIF
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                          NSSF
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                          Housing
                        </th>
                        {benefitsDeductions
                          .filter(bd => bd.type === 'benefit')
                          .map(bd => (
                            <th
                              key={bd.name}
                              className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider"
                            >
                              {bd.name}
                            </th>
                          ))}
                        {benefitsDeductions
                          .filter(bd => bd.type === 'deduction')
                          .map(bd => (
                            <th
                              key={bd.name}
                              className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider"
                            >
                              {bd.name}
                            </th>
                          ))}
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                         Bank Charge
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                          Net
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {payrollData.map(item => (
                        <tr key={item.user_id} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">{item.name || 'N/A'}</div>
                            <div className="text-sm text-slate-500">{item.payroll_index || 'N/A'}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            KES {Number(item.gross_salary || 0).toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            KES {Number(item.paye || 0).toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            KES {Number(item.shif || Math.max((item.gross_salary || 0) * 0.0275, 300)).toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            KES {Number(item.nssf || Math.min((item.gross_salary || 0) * 0.06, 8000)).toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            KES {Number(item.housing_levy || (item.gross_salary || 0) * 0.015).toLocaleString()}
                          </td>
                          {benefitsDeductions
                            .filter(bd => bd.type === 'benefit')
                            .map(bd => (
                              <td
                                key={bd.name}
                                className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                              >
                                KES {Number(item[bd.name] || item.details?.[bd.name] || 0).toLocaleString()}
                              </td>
                            ))}
                          {benefitsDeductions
                            .filter(bd => bd.type === 'deduction')
                            .map(bd => (
                              <td
                                key={bd.name}
                                className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                              >
                                KES {Number(item[bd.name] || item.details?.[bd.name] || 0).toLocaleString()}
                              </td>
                            ))}
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            KES {Number(item.bank_transfer_charges || 0).toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            KES {Number(item.net_pay || 0).toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            <button
                              onClick={() => downloadPayslip(item)}
                              disabled={generating}
                              className="text-blue-600 hover:text-blue-800 disabled:opacity-50 flex items-center space-x-1"
                              title="Download Payslip"
                            >
                              <Download className="h-4 w-4" />
                              <span>Payslip</span>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="bg-gray-100">
                      <tr>
                        <td className="px-6 py-4 font-semibold text-gray-900">Totals</td>
                        <td className="px-6 py-4 font-semibold text-gray-900">
                          KES {totalGross.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 font-semibold text-gray-900">
                          KES {totalPaye.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 font-semibold text-gray-900">
                          KES {totalShif.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 font-semibold text-gray-900">
                          KES {totalNssf.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 font-semibold text-gray-900">
                          KES {totalHousing.toLocaleString()}
                        </td>
                        {benefitTotals.map(b => (
                          <td key={b.name} className="px-6 py-4 font-semibold text-gray-900">
                            KES {b.total.toLocaleString()}
                          </td>
                        ))}
                        {deductionTotals.map(d => (
                          <td key={d.name} className="px-6 py-4 font-semibold text-gray-900">
                            KES {d.total.toLocaleString()}
                          </td>
                        ))}
                        <td className="px-6 py-4 font-semibold text-gray-900">
                          KES {totalCharge.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 font-semibold text-gray-900">
                          KES {totalNet.toLocaleString()}
                        </td>
                        <td className="px-6 py-4"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              ) : (
                <div className="text-center py-8">
                  <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-600">No payroll data available</p>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === 'compliance' && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">KRA Compliance</h3>
                <div className="space-y-3">
                  <div style={{cursor:'pointer'}} title="Download Paye"  onClick={() => generateReport('paye')} className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
                    <span className="text-sm font-medium">PAYE Returns</span>
                    <CheckCircle className="h-5 w-5 text-green-500" />
                  </div>
                  <div style={{cursor:'pointer'}} title="Download P9" onClick={() => generateReport('p9')} className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
                    <span className="text-sm font-medium">P9 Forms</span>
                    <CheckCircle className="h-5 w-5 text-green-500" />
                  </div>

                
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Statutory Deductions</h3>
                <div className="space-y-3">
                  <div style={{cursor:'pointer'}} title="Download SHIF" onClick={() => generateReport('shif')} className="flex justify-between items-center p-3 bg-blue-50 rounded-lg">
                    <span className="text-sm font-medium">SHIF Contributions</span>
                    <span className="text-sm font-semibold text-blue-600">
                      KES {totalShif.toLocaleString()}
                    </span>
                  </div>
                  <div style={{cursor:'pointer'}} title="Download NSSF" onClick={() => generateReport('nssf')} className="flex justify-between items-center p-3 bg-purple-50 rounded-lg">
                    <span className="text-sm font-medium">NSSF Contributions</span>
                    <span className="text-sm font-semibold text-purple-600">
                      KES {totalNssf.toLocaleString()}
                    </span>
                  </div>
                  <div style={{cursor:'pointer'}} title="Download Paye"  onClick={() => generateReport('paye')} className="flex justify-between items-center p-3 bg-red-50 rounded-lg">
                    <span className="text-sm font-medium">PAYE Tax</span>
                    <span className="text-sm font-semibold text-red-600">
                      KES {totalPaye.toLocaleString()}
                    </span>
                  </div>
                   <div style={{cursor:'pointer'}} title="Download Housing Levy" onClick={() => generateReport('housing')} className="flex justify-between items-center p-3 bg-yellow-50 rounded-lg">
                    <span className="text-sm font-medium">Housing Levy</span>
                   <CheckCircle className="h-5 w-5 text-green-500" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showProcessModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl max-w-md w-full p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-semibold text-gray-900">Process Payroll</h3>
                <button
                  onClick={() => setShowProcessModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ×
                </button>
              </div>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Select Month</label>
                  <input
                    type="month"
                    value={selectedMonth}
                    onChange={e => setSelectedMonth(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">NSSF Tier</label>
                  <select
                    value={nssfTier}
                    onChange={e => setNssfTier(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="both">Both Tiers</option>
                    <option value="tier1">Tier 1 Only</option>
                    <option value="tier2">Tier 2 Only</option>
                  </select>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="text-sm font-medium text-blue-900 mb-2">Processing will include:</h4>
                  <ul className="text-sm text-blue-800 space-y-1">
                    <li>• PAYE calculation per KRA rates</li>
                    <li>• SHIF deductions (2.75%)</li>
                    <li>• NSSF contributions (2026 rates)</li>
                    <li>• Housing Levy (1.5%)</li>
                    <li>• Personal relief (KES 2,400)</li>
                  </ul>
                </div>
                <div className="flex space-x-4 pt-4">
                  <button
                    onClick={() => setShowProcessModal(false)}
                    className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={processPayroll}
                    disabled={processing}
                    className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
                  >
                    {processing ? 'Processing...' : 'Process Payroll'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showReportsModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl max-w-md w-full p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-semibold text-gray-900">Generate Reports</h3>
                <button
                  onClick={() => setShowReportsModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ×
                </button>
              </div>
              {generating ? (
                <div className="text-center py-4">
                  <p className="text-gray-600">Generating report, please wait...</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {[
                    { name: 'P9 Forms', desc: 'Annual tax certificates', type: 'p9' },
                    { name: 'Payroll Summary', desc: 'Complete payroll summary', type: 'summary' },
                    { name: 'PAYE Schedule', desc: 'Monthly PAYE summary', type: 'paye' },
                    { name: 'SHIF Report', desc: 'SHIF contributions report', type: 'shif' },
                    { name: 'NSSF Report', desc: 'NSSF contributions report', type: 'nssf' },
                    { name: 'Housing Levy Report', desc: 'Housing levy contributions', type: 'housing' },
                    
                    { name: 'NITA Reports', desc: 'Nita contributions report', type: 'nita' },
                  ].map(report => (
                    <div
                      key={report.type}
                      className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      <div className="flex justify-between items-center">
                        <div>
                          <div className="font-medium text-gray-900">{report.name}</div>
                          <div className="text-sm text-slate-500">{report.desc}</div>
                        </div>
                        <button
                          onClick={() => generateReport(report.type)}
                          disabled={generating}
                          className="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
                        >
                          View
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default KenyanPayroll;